export default [
    {
        title: '首页',
        name: 'index'
    },
    {
        title: '明星',
        name: 'star'
    },
    {
        title: '活动',
        name: 'active'
    },
    {
        title: '话题',
        name: 'topic'
    },
    {
        title: 'APP下载',
        name: 'download'
    }
]
